module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-uniforme-polo-personalizado.a2c2cc2f.jpg";